module.exports = __webpack_public_path__ + "img/bg.695cd58e.svg";